import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {addItem} from "../cart/cart";
import {useState} from "react";

function fmt(n){ return new Intl.NumberFormat("sk-SK",{style:"currency",currency:"EUR"}).format(n||0); }

export default function ProductCard({ product }) {

    var [added, setAdded] = useState(false);

    function handleAddToCart(product) {
        if (!product) return;
        if (product.quantity < 1){
            alert("Tento produkt momentálne nie je skladom.");
            return;
        }
        if (!added) {
            addItem(product, 1);
            setAdded(true);
        }
        // re-trigger toast
        // setToastOpen(false);
        // setTimeout(() => setToastOpen(true), 0);
    }

    return (
        <motion.div
            whileHover={{ y: -4 }}
            transition={{ type: "spring", stiffness: 250, damping: 18 }}
            className="card product-card h-100 shadow-sm"
        >
            {/* Obrázok – 4:3 aspect */}
            <Link to={`/produkt/${product.slug || product.id}`} className="ratio ratio-4x3 product-thumb">
                <img
                    src={product.imageUrl || "/images/hodiny3.png"}
                    onError={e=> e.currentTarget.src="/images/hodiny3.png"}
                    alt={product.name}
                    className="img-cover rounded-top"
                />
            </Link>

            <div className="card-body d-flex flex-column">

                <Link to={`/produkt/${product.slug || product.id}`} className="text-decoration-none text-dark flex-grow-1 d-flex flex-column">
                    <h2 className="h5 mb-1">{product.name}</h2>

                    {/* malé štítky */}
                    <div className="mb-2 small text-muted d-flex gap-2 flex-wrap">
                        {product.wood && <span className="badge text-bg-light border">{product.wood}</span>}
                        {product.size && <span className="badge text-bg-light border">{product.size}</span>}
                        {product.subcategory && <span className="badge text-bg-light border">{product.subcategory}</span>}
                    </div>

                    {/* clamped popis */}
                    {product.description && (
                        <p className="product-desc flex-grow-1">
                            {product.description}
                        </p>
                    )}
                </Link>

                <div className="d-flex align-items-center justify-content-between mt-2">
                    <div className="fw-bold">{fmt(product.price)}</div>
                    {/*<Link to={`/produkt/${product.slug || product.id}`} className="btn btn-outline-secondary btn-sm">*/}
                    {/*    Detail*/}
                    {/*</Link>*/}
                    {/*
                    {added ? (
                        // <button type="button" className="btn btn-success btn-sm" disabled>
                        //     ✓ Pridané do košíka
                        // </button>
                        <p className="text-success m-1 fw-bold">
                            ✓ Pridané do košíka
                        </p>
                    ) : (
                    <button
                        type="button"
                        className="btn btn-brown btn"
                        onClick={() => handleAddToCart(product)}
                    >
                        <i className="bi bi-cart3"></i>
                        <span className="d-sm-inline">&nbsp;do košíka</span>
                    </button>
                    )}
                    */}
                </div>
            </div>
        </motion.div>
    );
}
